/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ShopOrderClientControllerDeleteReadyOrderV1$Params {

/**
 * 주문 번호
 */
  orderNumber: string;
}

export function shopOrderClientControllerDeleteReadyOrderV1(http: HttpClient, rootUrl: string, params: ShopOrderClientControllerDeleteReadyOrderV1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, shopOrderClientControllerDeleteReadyOrderV1.PATH, 'delete');
  if (params) {
    rb.path('orderNumber', params.orderNumber, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

shopOrderClientControllerDeleteReadyOrderV1.PATH = '/api/v1/shop-orders/client/{orderNumber}/ready';
